



































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { Button as ElButton, ButtonGroup } from 'element-ui'

import ArrayItemActions from './base/ArrayItemActions.vue'

@Component({
  name: 'JsfSingleTypeArrayWrapper',
  components: {
    ElButton,
    ArrayItemActions,
  },
})
export default class JsfAlert extends Vue {
  @Prop({ required: true, type: Array }) list: any
  @Prop({ required: true, type: String }) title: any

  @Prop({ required: true, type: Function }) onDelete: any
  @Prop({ required: true, type: Function }) onAdd: any
  @Prop({ required: true, type: Function }) onUp: any
  @Prop({ required: true, type: Function }) onDown: any

  handleAddToLast() {
    this.onAdd(null, this.list.length - 1)
  }
}
